// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WcXeP","variantMinimal":"styles_variantMinimal__eTxeD","top":"styles_top__SvX9g","header":"styles_header___oXGz","text":"styles_text__SOj__"};